export default function footerDropdownsHandler() {
    const menuItems = $('#injected-footer .menu-item-has-children');

    // const toggleSubMenu = () => {
    //     if(!$(this).hasClass('submenu-open')) {
    //         menuItems.removeClass('submenu-open');
    //         $(this).addClass('submenu-open');
    //     } else {
    //         menuItems.removeClass('submenu-open');
    //     }
    // };

    const scrollUp = (menuItem) => {
        $('.scroll-up').hover(function() {
            $(menuItem).addClass('slide-up');
        });

        $(menuItem).mouseleave(function() {
            $(menuItem).removeClass('slide-up');
        });
    };

    menuItems.each(function() {
        // $(this).hover(toggleSubMenu);
        // $(this).click(toggleSubMenu);

        if($(this).hasClass('menu-item-13457')) {
            scrollUp($(this));
        }
    });
}


// WEBPACK FOOTER //
// ./scriptPartials/footerDropdownsHandler.js